import React, { type FC, memo, use, useMemo } from "react";
import { ReadinessContext } from "@domain/context/DataReadyness";
import { Tooltip } from "@heroui/react";

const states = {
    online: {
        state: "green",
        stateDesc: "Online. You are connected to the remote database.",
    },
    offline: {
        state: "red",
        stateDesc: "Offline. All changes will be saved when you connect to the internet.",
    },
    initializing: {
        state: "yellow",
        stateDesc: "Initializing. We are connecting to the database.",
    },
};

const IndicatorImpl: FC = () => {
    const { isReady, isConnected, loadingTexts } = use(ReadinessContext);

    const state = useMemo(() => {
        if (!isConnected) {
            return states.offline;
        }
        return isReady ? states.online : states.initializing;
    }, [isConnected, isReady]);

    const lampClass = "mt-2 led-lamp led-lamp-" + state?.state;
    const packageJson = JSON.parse(import.meta.env.VITE_PACKAGE_JSON || "{}");
    const binalePackages = Object.keys(packageJson.dependencies ?? {}).filter((key) => key.startsWith("@binale"));

    return (
        <div className="Header--IndicatorContainer">
            <Tooltip delay={0} closeDelay={0}>
                <Tooltip.Trigger>
                    <i className={lampClass} />
                </Tooltip.Trigger>
                <Tooltip.Content placement="bottom end" offset={12}>
                    <Tooltip.Arrow />
                    <div className="text-left">
                        <strong className="text-blue-600">{state.stateDesc}</strong>
                        <div>{import.meta.env.VITE_VERSION || "local"}</div>
                        {binalePackages.map((key) => (
                            <div key={key}>{`${key}: ${packageJson.dependencies[key]}`}</div>
                        ))}
                        <div>
                            {loadingTexts.map((text, idx) => {
                                return <p key={idx}>{text}</p>;
                            })}
                        </div>
                    </div>
                </Tooltip.Content>
            </Tooltip>
        </div>
    );
};

export const Indicator = memo(IndicatorImpl);
